import { Injectable } from '@angular/core';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as UserActions from './user.actions';
import { ConnectServerService } from '../../services/connect-server.service';
import { Connect } from '../../classes/connect';
import { Actions, createEffect, ofType } from '@ngrx/effects';

@Injectable()
export class UserEffects {

  loadUserInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.loadUserInfo),
      mergeMap(() => this.connectServerService.getRequestLara(Connect.urlServerLaraApi, 'user',
        {}
      )
        .pipe(
          map((userInfo: any) => UserActions.loadUserInfoSuccess({ userInfo })),
          catchError(error => of(UserActions.loadUserInfoFailure({ error })))
        ))
    )
  );

  loadUserPermissions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.loadUserPermissions),
      mergeMap(() => this.connectServerService.getRequestLara(Connect.urlServerLaraApi, 'user/authorizations', {})
        .pipe(
          map((permissions: any) => UserActions.loadUserPermissionsSuccess({ permissions })),
          catchError(error => of(UserActions.loadUserPermissionsFailure({ error })))
        ))
    )
  );

  loadUserCompany$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.loadUserCompanyInfo),
      mergeMap(() => this.connectServerService.getRequestLara(Connect.urlServerLaraApi, 'user/company', {})
        .pipe(
          map((companyInfo: any) => UserActions.loadUserCompanyInfoSuccess({ companyInfo })),
          catchError(error => of(UserActions.loadUserCompanyInfoFailure({ error })))
        ))
    )
  );

  constructor(
    private actions$: Actions,
    private connectServerService: ConnectServerService
  ) { }
}
